module.exports = __webpack_public_path__ + "img/eyebox.248462e6.svg";